// "localhost:3000" is a host and a port, not a scheme.
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:(?!\d)/i;

/** The http(s) URL to link to, or null. Adds "https://" when the scheme is missing. */
export function normalizeWebUrl(input: string | undefined): string | null {
    const value = input?.trim();
    if (!value) return null;
    try {
        const url = new URL(
            HAS_SCHEME.test(value) ? value : `https://${value}`
        );
        return url.protocol === "http:" || url.protocol === "https:"
            ? url.href
            : null;
    } catch {
        return null;
    }
}
